export const companias = [
  {
    "value": 698,
    "title": "SIN SEGURO"
  },
  {
    "value": 699,
    "title": "OTROS"
  },
  {
    "value": 9000000,
    "title": "ATM Aseguradora Total Motovehicular"
  },
  {
    "value": 444,
    "title": "ACONCAGUA SEGUROS DE RETIRO S.A."
  },
  {
    "value": 497,
    "title": "ALICO CIA.DE SEGUROS S.A."
  },
  {
    "value": 24,
    "title": "ALLIANCE ASSURANCE COMPANY LIMITED"
  },
  {
    "value": 109,
    "title": "Allianz Argentina Cia de Seguros S.A."
  },
  {
    "value": 329,
    "title": "ALBA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 202,
    "title": "AMERICAN HOME ASSURANCE COMPANY"
  },
  {
    "value": 331,
    "title": "ANTA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 246,
    "title": "ANTARTIDA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 430,
    "title": "ANTICIPAR SEGUROS DE RETIRO S.A."
  },
  {
    "value": 241,
    "title": "ARGOS COMPAÑÍA ARGENTINA DE SEGUROS GRALES SA"
  },
  {
    "value": 199,
    "title": "ASOCIACION MUTUAL DAM"
  },
  {
    "value": 239,
    "title": "ASSICURAZIONI GENERALI SOCIETA PER AZIONI"
  },
  {
    "value": 332,
    "title": "ASTRO COOPERATIVA DE SEGUROS LTDA."
  },
  {
    "value": 438,
    "title": "ASEGURADORES SOLIDARIOS SEGUROS DE RETIRO"
  },
  {
    "value": 335,
    "title": "ASEGURADORES INDUSTRIALES S.A.CIA.ARG.DE SEG."
  },
  {
    "value": 415,
    "title": "ASEGURADORES DE CAUCIONES S.A.CIA.DE SEGUROS"
  },
  {
    "value": 439,
    "title": "ASEGURAR SEGUROS DE RETIRO S.A."
  },
  {
    "value": 297,
    "title": "ASEGURADORA DE CREDITOS Y GARANTIAS S.A."
  },
  {
    "value": 291,
    "title": "ASEGURADORA DE RIO NEGRO Y NEUQUEN S.A."
  },
  {
    "value": 147,
    "title": "ASEGURADORA DEL LITORAL S.A."
  },
  {
    "value": 394,
    "title": "AVANZADA COOPERATIVA DE SEGUROS LIMITADA"
  },
  {
    "value": 43,
    "title": "BELGRANO SOC.COOPERATIVA LTDA.DE SEGUROS"
  },
  {
    "value": 222,
    "title": "BERNARDINO RIVADAVIA SOC.COOPERATIVA DE SEG."
  },
  {
    "value": 32,
    "title": "BOSTON COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 148,
    "title": "BRADESCO ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 339,
    "title": "BRB SEGUROS S.A."
  },
  {
    "value": 245,
    "title": "CAJA NACIONAL DE AHORRO Y SEGURO"
  },
  {
    "value": 259,
    "title": "CAJA POPULAR DE AHORRO DE LA PCIA.DE TUCUMAN"
  },
  {
    "value": 340,
    "title": "CAJA DE JUB.SUB.PENS.DEL PERS.BCO.PCIA.BS.AS."
  },
  {
    "value": 501,
    "title": "CAJA DE SEGUROS S.A."
  },
  {
    "value": 502,
    "title": "CAJA DE SEGUROS DE VIDA S.A."
  },
  {
    "value": 57,
    "title": "CALEDONIA ARGENTINA COMPAÑÍA DE SEGUROS S.A."
  },
  {
    "value": 406,
    "title": "CARUSO COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 322,
    "title": "CENIT COMPAÑÍA ARGENTINA DE SEG.GRALES.S.A."
  },
  {
    "value": 491,
    "title": "CERTEZA CIA.DE SEGUROS DE RETIRO S.A."
  },
  {
    "value": 359,
    "title": "COLON COMPAÑÍA DE SEGUROS GENERALES S.A."
  },
  {
    "value": 19,
    "title": "COLUMBIA SOCIEDAD ANONIMA DE SEGUROS"
  },
  {
    "value": 75,
    "title": "COMMERCIAL UNION COMPAÑÍA DE SEGUROS S.A."
  },
  {
    "value": 36,
    "title": "COMPAÑÍA ASEGURADORA AR.S.A.DE SEG.GRALES."
  },
  {
    "value": 136,
    "title": "COMPAÑÍA MERCANTIL ASEGURADORA S.A.ARG.DE SEGURO"
  },
  {
    "value": 138,
    "title": "COMPAÑÍA MERCANTIL ASEGURADORA S.A. ARG. DE SEG."
  },
  {
    "value": 298,
    "title": "CONGRESO CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 379,
    "title": "CONOSUD COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 196,
    "title": "COOPERACION MUTUAL PATRONAL SOC.MUTUAL SEG."
  },
  {
    "value": 272,
    "title": "COOPERACION GREMIAL COOP.DE SEGUROS LTDA."
  },
  {
    "value": 281,
    "title": "COOPERATIVA DE SEG.NAVIEROS LTDA."
  },
  {
    "value": 248,
    "title": "COPAN COOPERATIVA DE SEGUROS LTDA."
  },
  {
    "value": 270,
    "title": "COSECHA COOPERATIVA DE SEGUROS LTDA."
  },
  {
    "value": 404,
    "title": "CREDITO A LA EXPORTACION CIA.ARG.DE SEGUROS"
  },
  {
    "value": 300,
    "title": "CUMBRE COOPERATIVA ARGENTINA DE SEGUROS LTDA."
  },
  {
    "value": 356,
    "title": "CUSPIDE COMPAÑÍA ARGENTINA DE SEGUROS"
  },
  {
    "value": 280,
    "title": "CUYO COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 141,
    "title": "EL NORTE COMPAÑÍA DE SEGUROS S.A."
  },
  {
    "value": 2,
    "title": "EL PLATA S.A.ARGENTINA DE SEGUROS"
  },
  {
    "value": 500,
    "title": "EL PLATA SEGUROS DE VIDA S.A."
  },
  {
    "value": 6,
    "title": "EL SURCO COMPAÑÍA DE SEGUROS S.A."
  },
  {
    "value": 207,
    "title": "EL FUERTE COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 143,
    "title": "EL PROGRESO AGRICOLA DE PIGUE COOP.DE SEG."
  },
  {
    "value": 168,
    "title": "EL PORVENIR COOPERATIVA DE SEGUROS LIMITADA"
  },
  {
    "value": 11,
    "title": "EL COMERCIO COMPAÑÍA DE SEGUROS A PRIMA FIJA"
  },
  {
    "value": 269,
    "title": "EL CENTINELA COOPERATIVA DE SEGUROS LTDA."
  },
  {
    "value": 355,
    "title": "ESCUDO COOPERATIVA LTDA.DE SEGUROS"
  },
  {
    "value": 37,
    "title": "ESPAÑA Y RIO DE LA PLATA CIA.ARG.DE SEG.S.A."
  },
  {
    "value": 498,
    "title": "FADAF SEGUROS DE SEPELIO S.A."
  },
  {
    "value": 203,
    "title": "FATA SOCIEDAD DE SEGUROS MUTUOS"
  },
  {
    "value": 278,
    "title": "FEDERACION AGRARIA ARG.SOC.COOP.SEG.LTDA."
  },
  {
    "value": 146,
    "title": "FEDERACION AGRARIA ARG. DE SEGUROS DE RETIRO"
  },
  {
    "value": 128,
    "title": "FEDERACION PATRONAL SEGUROS S.A."
  },
  {
    "value": 425,
    "title": "FEDERACION PATRONAL SEGUROS DE RETIRO S.A."
  },
  {
    "value": 130,
    "title": "FENIX DEL NORTE CIA.ARG.DE SEG.S.A."
  },
  {
    "value": 208,
    "title": "FIREMEN'S INSURANCE COMPANY OF NEWARK"
  },
  {
    "value": 341,
    "title": "FLORENCIA CIA.ARG.DE SEGUROS GRALES.S.A."
  },
  {
    "value": 323,
    "title": "GARANTIA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 80,
    "title": "GENERAL DE FINANZAS Y GARANTIAS S.A.CIA.SEG."
  },
  {
    "value": 399,
    "title": "GENERAL PAZ COOP.LTDA.DE SEGUROS"
  },
  {
    "value": 333,
    "title": "HAMBURGO CIA.DE SEGUROS S.A."
  },
  {
    "value": 182,
    "title": "HERMES COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 261,
    "title": "HORIZONTE CIA.ARG.DE SEGUROS GRALES.S.A."
  },
  {
    "value": 488,
    "title": "I.T.T. HARFORD SEGUROS DE RETIRO S.A."
  },
  {
    "value": 228,
    "title": "IGUAZU COMPAÑÍA DE SEGUROS S.A."
  },
  {
    "value": 318,
    "title": "INCA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 448,
    "title": "INCA S.A. CIA.DE SEGUROS DE RETIRO"
  },
  {
    "value": 252,
    "title": "INDEPENDENCIA COMPAÑÍA ARG.DE SEGUROS S.A."
  },
  {
    "value": 255,
    "title": "INDIA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 327,
    "title": "INSURANCE COMPANY OF NORTH AMERICA"
  },
  {
    "value": 12,
    "title": "INSTITUTO ITALO ARG.DE SEGUROS GRALES.S.A."
  },
  {
    "value": 254,
    "title": "INSTITUTO AUTARTICO PCIAL.DEL SEG.ENTRE RIOS"
  },
  {
    "value": 437,
    "title": "INST.AUT.PROV.DEL SEG. ENTRE RIOS"
  },
  {
    "value": 302,
    "title": "INSTITUTO PCIAL.DE SEGUROS PROVINCIA DE SALTA"
  },
  {
    "value": 303,
    "title": "INSTITUTO PCIAL.DEL SEGURO DE MISIONES"
  },
  {
    "value": 367,
    "title": "INSTITUTO COOP.DE SEGUROS COOP.SEG.GRALES.LTD"
  },
  {
    "value": 381,
    "title": "INSTITUTO ASEGURADOR MERCANTIL CIA.ARG.SEG.SA"
  },
  {
    "value": 354,
    "title": "INTERAMERICANA CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 423,
    "title": "INTERNACIONAL CIA.DE SEGUROS DE VIDA"
  },
  {
    "value": 7,
    "title": "JUNCAL COMPAÑÍA DE SEGUROS S.A."
  },
  {
    "value": 368,
    "title": "JUPITER COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 39,
    "title": "LA BUENOS AIRES CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 443,
    "title": "LA BUENOS AIRES - NEW YORK LIFE SEG DE RETIRO"
  },
  {
    "value": 338,
    "title": "LA CONFIANZA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 236,
    "title": "LA CONSTRUCCION S.A.CIA.ARGENTINA DE SEG."
  },
  {
    "value": 96,
    "title": "LA CONTINENTAL CIA.DE SEGUROS GRALES.S.A."
  },
  {
    "value": 158,
    "title": "LA DULCE COOPERATIVA DE SEGUROS LTDA."
  },
  {
    "value": 54,
    "title": "LA ECONOMIA COMERCIAL S.A.DE SEG.GRALES."
  },
  {
    "value": 44,
    "title": "LA EQUITATIVA DEL PLATA S.A.DE SEGUROS"
  },
  {
    "value": 294,
    "title": "LA ESTRELLA CIA.DE SEGUROS DE VIDA S.A."
  },
  {
    "value": 419,
    "title": "LA ESTRELLA S.A. CIA.DE SEGUROS S.A."
  },
  {
    "value": 416,
    "title": "LA FORTUNA S.A.ARGENTINA DE SEG.GRALES."
  },
  {
    "value": 79,
    "title": "LA HOLANDO SUDAMERICANA SEGUROS DE RETIRO"
  },
  {
    "value": 103,
    "title": "LA IBERO PLATENSE CIA.DE SEGUROS S.A."
  },
  {
    "value": 452,
    "title": "LA IBERO PLATENSE CIA.DE SEGUROS DE RETIRO"
  },
  {
    "value": 346,
    "title": "LA INDUSTRIAL COOP.DE SEGUROS LTDA."
  },
  {
    "value": 116,
    "title": "LA MERCANTIL ANDINA S.A.CIA.DE SEGUROS"
  },
  {
    "value": 5,
    "title": "LA MERCANTIL ROSARINA CIA.DE SEGUROS S.A."
  },
  {
    "value": 244,
    "title": "LA MERIDIONAL CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 163,
    "title": "LA NUEVA SOC.COOP.DE SEGUROS LTDA."
  },
  {
    "value": 257,
    "title": "LA PATAGONIA CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 157,
    "title": "LA PERSEVERANCIA DEL SUR S.A.ARG.DE SEGUROS"
  },
  {
    "value": 218,
    "title": "LA PORTEÑA CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 139,
    "title": "LA PREVISION COOP.DE SEGUROS LTDA."
  },
  {
    "value": 451,
    "title": "LA PREVISION SEGUROS DE RETIRO COOP."
  },
  {
    "value": 68,
    "title": "LA REPUBLICA SEGUROS DE VIDA S.A."
  },
  {
    "value": 69,
    "title": "LA REPUBLICA CIA.ARG.DE SEG.GRLES.S.A."
  },
  {
    "value": 117,
    "title": "LA SEGUNDA CIA.ARG.DE SEG.GRALES.S.A."
  },
  {
    "value": 436,
    "title": "LA SEGUNDA SEGUROS DE RETIRO S.A."
  },
  {
    "value": 209,
    "title": "LA SUIZO CIA.ARG. DE SEGUROS S.A."
  },
  {
    "value": 140,
    "title": "LA TANDILENSE CIA.ARG.DE SEGUROS S.A."
  },
  {
    "value": 231,
    "title": "LA TERCERA CIA.DE SEGUROS GRALES.S.A."
  },
  {
    "value": 229,
    "title": "LA TERRITORIAL DE SEGUROS S.A."
  },
  {
    "value": 95,
    "title": "LA UNION AGRICOLA COOP.DE SEGUROS LTDA."
  },
  {
    "value": 121,
    "title": "LA UNION GREMIAL CIA.DE SEGUROS S.A."
  },
  {
    "value": 344,
    "title": "LA URUGUAYA ARGENTINA CIA.DE SEGUROS S.A."
  },
  {
    "value": 412,
    "title": "LATITUD SUR S.A.CIA.ARG.DE SEGUROS"
  },
  {
    "value": 311,
    "title": "LIBERTAD COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 264,
    "title": "LIGA DE SEGUROS DE JUNIN SOC.COOP.LTDA."
  },
  {
    "value": 352,
    "title": "LIDERAR CIA.GRAL.DE SEGUROS S.A."
  },
  {
    "value": 395,
    "title": "LONDRES Y RIO DE LA PLATA CIA.ARG.DE SEG.S.A."
  },
  {
    "value": 325,
    "title": "LOS ANDES CIA.DE SEGUROS S.A."
  },
  {
    "value": 61,
    "title": "L'UNION DES ASSURANCE DE PARIS I.A.R.D."
  },
  {
    "value": 388,
    "title": "LUZ Y FUERZA COOP.DE SEGUROS LTDA."
  },
  {
    "value": 432,
    "title": "MAÑANA ASEGURADORES ASOC.S.A. SEGUROS"
  },
  {
    "value": 213,
    "title": "MAPFRE ACONCAGUA CIA.DE SEGUROS S.A."
  },
  {
    "value": 374,
    "title": "MAYOR SEGUROS COOP.LTDA."
  },
  {
    "value": 233,
    "title": "MERCOSUR CIA.AMERICANA DE SEGUROS S.A."
  },
  {
    "value": 334,
    "title": "METROPOL COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 247,
    "title": "NATIVA CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 9,
    "title": "NUMANCIA SEGUROS EN GENERAL"
  },
  {
    "value": 227,
    "title": "OCEANO CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 288,
    "title": "OLAM COOP.DE SEGUROS LTDA."
  },
  {
    "value": 293,
    "title": "ORBIS COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 282,
    "title": "PERGAMINO COOP.DE SEGUROS LTDA."
  },
  {
    "value": 46,
    "title": "PHOENIX ASSURANCE COMPANY LIMITED"
  },
  {
    "value": 263,
    "title": "PLUS ULTRA CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 431,
    "title": "PROFUTURO CIA.DE SEGUROS DE RETIRO S.A."
  },
  {
    "value": 55,
    "title": "PROVIDENCIA CIA.DE SEGUROS DE RETIROS S.A."
  },
  {
    "value": 428,
    "title": "PROVIDENCIA CIA.DE SEGUROS DE RETIRO S.A."
  },
  {
    "value": 40,
    "title": "PRUDENCIA CIA.ARGENTINA DE SEGUROS DE RETIRO"
  },
  {
    "value": 499,
    "title": "PROVINCIA SEGUROS DE VIDA S.A."
  },
  {
    "value": 484,
    "title": "PROYECCION SEGUROS DE RETIRO S.A."
  },
  {
    "value": 348,
    "title": "PRODUCTORES DE FRUTAS ARGENTINAS COOP.SEG.LTD"
  },
  {
    "value": 296,
    "title": "REAL ( ARGENTINA ) DE SEGUROS S.A."
  },
  {
    "value": 440,
    "title": "RECONQUISTA SOC.ARG.DE SEGUROS DE RETIRO"
  },
  {
    "value": 418,
    "title": "REASEGURADORAS ARGENTINA S.A."
  },
  {
    "value": 360,
    "title": "RIO URUGUAY COOP.DE SEGUROS LTDA."
  },
  {
    "value": 258,
    "title": "RIUNIONE ADRIATICA DI SICURTA SOC.PER AZIONE"
  },
  {
    "value": 47,
    "title": "ROYAL EXCHANGE ASSURANCE"
  },
  {
    "value": 25,
    "title": "S.A. COMPAÑÍA DE SEGUROS LOS ANDES"
  },
  {
    "value": 131,
    "title": "SAN MARTIN CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 192,
    "title": "SAN CRISTOBAL SOC.MUTUAL DE SEGUROS GRALES."
  },
  {
    "value": 442,
    "title": "SAN CRISTOBAL SEGURO DE RETIRO S.A."
  },
  {
    "value": 409,
    "title": "SAN NICOLAS CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 224,
    "title": "SANCOR COOP.DE SEGUROS LTDA."
  },
  {
    "value": 427,
    "title": "SANCOR SEGUROS DE RETIRO S.A."
  },
  {
    "value": 494,
    "title": "SECURITY LEGAL PREPAYMENT SYSTEM S.A. CIA."
  },
  {
    "value": 216,
    "title": "SEGURCOOP COOPERATIVA DE SEGUROS LIMITADA"
  },
  {
    "value": 277,
    "title": "SEGURIDAD COOPERATIVA DE SEGUROS LIMITADA"
  },
  {
    "value": 286,
    "title": "SEGUROMETAL COOP.DE SEGUROS LTDA."
  },
  {
    "value": 413,
    "title": "SENTIR SEGUROS S.A."
  },
  {
    "value": 396,
    "title": "SIGLO XXI CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 420,
    "title": "SIEMBRA SEGUROS DE RETIRO S.A."
  },
  {
    "value": 243,
    "title": "SOCIEDAD RURAL DE CEREALISTAS CIA.ARG.DE SEG.S.A"
  },
  {
    "value": 312,
    "title": "SOLVENCIA S.A.DE SEGUROS GENERALES"
  },
  {
    "value": 23,
    "title": "SUD AMERICA VIDA Y PATRIMONIALES S.A."
  },
  {
    "value": 33,
    "title": "SUD AMERICA TERRESTRE Y MARITIMA CIA.SEG.S.A."
  },
  {
    "value": 274,
    "title": "SUIZO ARGENTINA CIA.DE SEGUROS S.A."
  },
  {
    "value": 251,
    "title": "SUR CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 408,
    "title": "THE TOKIO MARINE AND FIRE INSURANCE COM.LIMIT"
  },
  {
    "value": 22,
    "title": "TOURING COOP.DE SEGUROS LTDA."
  },
  {
    "value": 105,
    "title": "TRAINMET SEGUROS S.A."
  },
  {
    "value": 402,
    "title": "TRIUNFO COOP.DE SEGUROS LTDA."
  },
  {
    "value": 3,
    "title": "TUTELAR SEGUROS S.A."
  },
  {
    "value": 275,
    "title": "ULTRAMAR SOCIEDAD ANONIMA DE SEGUROS"
  },
  {
    "value": 113,
    "title": "UNION PANADERIL COOPERATIVA DE SEGUROS LIMITADA"
  },
  {
    "value": 34,
    "title": "UNION DE COMERCIANTES S.A.CIA.DE SEGUROS"
  },
  {
    "value": 363,
    "title": "VANGUARDIA COMPAÑÍA ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 64,
    "title": "VICTORIA CIA.ARGENTINA DE SEGUROS S.A."
  },
  {
    "value": 392,
    "title": "VISION S.A.CIA.ARGENTINA DE SEGUROS"
  },
  {
    "value": 71,
    "title": "WINTERTHUR INTERNACIONAL ARG. S.A. CIA. DE"
  },
  {
    "value": 369,
    "title": "ZURICH CIA.DE SEGUROS"
  },
  {
    "value": 422,
    "title": "ZURICH - IGUAZU COMPAÑÍA DE SEGUROS DE RETIRO"
  },]